module.exports = __webpack_public_path__ + "img/II-10.0ebf8ecf.svg";